import React, { type ComponentType, lazy, Suspense } from 'react';

import type { FeedbackCollectorProps } from './types';

const FeedbackDialogSuspense = lazy(
	() => import(/* webpackChunkName: "async-ptc_feedback-dialog" */ './FeedbackCollector'),
);

const FeedbackDialogLazyNext = (props: FeedbackCollectorProps): React.ReactElement => (
	<Suspense fallback={null}>
		<FeedbackDialogSuspense {...props} />
	</Suspense>
);

const FeedbackDialogLazy: ComponentType<FeedbackCollectorProps> = (
	props: FeedbackCollectorProps,
): React.ReactElement => <FeedbackDialogLazyNext {...props} />;
FeedbackDialogLazy.displayName = 'lazy(FeedbackDialog)';

export default FeedbackDialogLazy;
